// extracted by mini-css-extract-plugin
module.exports = {"logoLink":"jR","logoWrapper":"jS"};